/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'MailGroup'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('mailgroup'); // main translation loaded for mailgroup
		$translatePartialLoader.addPart('relationmailgroup'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/mailgroup/mailgroup-dialog.html';

		return {
			/* new state for entity mailGroup */
			/* to access: ui-ref="mailgroup.list.new" */
			/* url: hostname/mailgroup/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'MailGroupDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'MailGroupFactory',
									'NewMailGroupFactory',
									function(MailGroupFactory, NewMailGroupFactory) {
										if (isEditMode) {
											// get the entity by its ID
											return MailGroupFactory.get({ id: $stateParams.mailGroupId }).$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										} else {
											// get a new empty entity
											return NewMailGroupFactory.get().$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for mailGroup new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for mailGroup edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('mailgroup', {
		/* abstract state for entity mailGroup */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/mailgroup',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'MailGroups',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('mailgroup.list', {
		/* list state for entity mailGroup */
		/* to access: ui-ref="mailgroup.list" */
		/* url: hostname/mailgroup/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/mailgroup/mailgroups.html',
				controller: 'MailGroupController',
			},
		},
	});

	$stateProvider.state('mailgroup.detail', {
		/* detail state for entity mailGroup */
		/* to access: ui-sref="mailgroup.detail" */
		/* url: hostname/mailgroup/detail/:mailGroupId */
		url: '/detail/:mailGroupId',
		views: {
			'content@': {
				templateUrl: 'app/entities/mailgroup/mailgroup-detail.html',
				controller: 'MailGroupDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'MailGroupFactory',
				function($stateParams, MailGroupFactory) {
					return MailGroupFactory.get({ id: $stateParams.mailGroupId });
				},
			],
		},
	});

	/* url: http://<hostname>/mailgroup/list/new */
	$stateProvider.state('mailgroup.list.new', getNewState());
	/* url: http://<hostname>/mailgroup/list/:mailGroupId/edit */
	$stateProvider.state('mailgroup.list.edit', getEditState('/:mailGroupId/edit'));
	/* url: http://<hostname>/mailgroup/detail/:mailGroupId/edit */
	$stateProvider.state('mailgroup.detail.edit', getEditState('/edit'));

	$stateProvider.state('relationmailgroup.list.newMailGroup', getNewState('/mailgroup/new'));
});
